export const px2vw = (pixels) => {
  const pixelTotal = 750;
  const unitPrecision = 3;
  const minPixelValue = 1;
  if (pixels <= minPixelValue) {
    return `${pixels}px`;
  }
  return `${((pixels / pixelTotal) * 100).toFixed(unitPrecision)}vw`;
};

export const getElementOffset = (element) => window.pageYOffset + element.getBoundingClientRect().top;

// 由于滚动惯性的原因，可能当前计算的高度已经不如滚动惯性了，所以判断是否执行滚动还是任由惯性执行
const excuteScrollTo = (direction, target) => {
  if (direction === 'down') {
    return window.pageYOffset < target;
  }
  if (direction === 'up') {
    return window.pageYOffset > target;
  }
};

// 滚动到元素
const stepTime = 15;
let scrollInterval = null;
const scrollToElement = (element, interval, options, direction, callback) => {
  const offset = getElementOffset(element);
  const initialOffset = window.pageYOffset;

  const scrollHeight = offset - initialOffset;

  const scrollStep = Math.PI / (interval / stepTime);
  const cosParameter = scrollHeight / 2;
  let scrollCount = 0;
  let scrollMargin;
  let previousScrollMargin;
  let signChanged = false;
  const gap = options && options.gap ? options.gap : 0;

  clearInterval(scrollInterval);
  scrollInterval = setInterval(() => {
    // Elelement we want to scroll to below current scroll position
    if ((window.pageYOffset < offset - gap || window.pageYOffset > offset) && !signChanged) {
      scrollCount = scrollCount + 1;
      scrollMargin = cosParameter - cosParameter * Math.cos(scrollCount * scrollStep);

      if (previousScrollMargin) {
        signChanged = Math.abs(scrollMargin) < Math.abs(previousScrollMargin);
      }
      const currentTargetOffset = initialOffset + scrollMargin - gap;
      if (excuteScrollTo(direction, currentTargetOffset)) {
        window.scrollTo(0, currentTargetOffset);
      }
      previousScrollMargin = scrollMargin;
    } else {
      clearInterval(scrollInterval);
      window.scrollTo(0, offset);
      if (callback) {
        callback();
      }
    }
  }, stepTime);
};

export const clearScrollInterval = () => {
  clearInterval(scrollInterval);
};

/**
 * 动画垂直滚动到页面指定元素位置
 * @param { String } id 元素id
 *
 */
export const scrollAnimation = (targetEle, interval = 500, direction, callback) => {
  if (targetEle) {
    scrollToElement(targetEle, interval, { gap: 0 }, direction, callback);
  }
};

export const getScrollTop = () =>
  window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

export const getInnerHeight = () =>
  window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight || 0;

export const getInnerWidth = () =>
  window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth || 0;

export const getPageHeight = () => {
  const innerHeight = getInnerHeight();
  const innerWidth = getInnerWidth();
  if (innerHeight) {
    if (innerWidth / innerHeight <= 750 / 1624) {
      return innerHeight;
    }
    return innerWidth / (750 / 1624);
  }
  return undefined;
};

// 当前元素是否在视窗里，可以百分比在视图
export const ifInView = (wrapperEle, isLottie, percent = 1) => {
  if (wrapperEle) {
    const scrollTop = getScrollTop();
    const innerHeight = getInnerHeight();
    const offset = getElementOffset(wrapperEle) + (isLottie ? 604 * (innerHeight / 1624) : 0);
    const eleHeight = wrapperEle.offsetHeight - (isLottie ? 654 * (innerHeight / 1624) : 0);
    return offset >= scrollTop && offset + eleHeight * percent <= scrollTop + innerHeight;
  }
  return false;
};

// 当前元素是否完全离开视窗
export const ifOutView = (wrapperEle, isLottie) => {
  if (wrapperEle) {
    const scrollTop = getScrollTop();
    const innerHeight = getInnerHeight();
    const offset = getElementOffset(wrapperEle) + (isLottie ? 604 * (innerHeight / 1624) : 0);
    const eleHeight = wrapperEle.offsetHeight - (isLottie ? 654 * (innerHeight / 1624) : 0);
    return offset >= scrollTop + innerHeight || offset + eleHeight <= scrollTop;
  }
  return false;
};

// 当前元素是否已浏览
export const ifHaveView = (wrapperEle, isLottie) => {
  if (wrapperEle) {
    const scrollTop = getScrollTop();
    const innerHeight = getInnerHeight();
    const offset = getElementOffset(wrapperEle) - (isLottie ? 604 * (innerHeight / 1624) : 0);
    const eleHeight = wrapperEle.offsetHeight - (isLottie ? 654 * (innerHeight / 1624) : 0);

    return offset + eleHeight <= scrollTop + innerHeight;
  }
  return false;
};

export const isSetDefault = window.location.search.indexOf('isSetDefault=true') !== -1;

export const report = (options = {}) => {
  console.log('report', {
    beacon_event_name: 'SetingHomePage',
    ...options,
  });

  if (!window.browser?.qb?.beacon) {
    return;
  }

  window.browser.qb.beacon({
    beacon_event_name: 'SetingHomePage',
    ...options,
  });
};

export function getQueryVariable(name) {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i');
  const result = window.location.search.substr(1).match(reg);
  if (result !== null) {
    return decodeURI(result[2]);
  }
  return null;
}
